import {
  FormatServerName,
  ParseLocalTime,
  StatusClass,
  StatusClass2
} from '@/utils/helpers.js'

export default {
  computed: {
    tenantIsTorus () {
      return process.env.VUE_APP_TENANT_NAME === 'torus'
    },
    hasDashboardAccess () {
      const hasAccess = process.env.VUE_APP_DASHBOARD_ACCESS === 'true'
      return hasAccess
    },
    hasKyc () {
      return this.$store.state.auth.business.completedKyc
    },
    initiatorInfo () {
      return this.$store.state.auth.transactionInitiator
    }
  },
  methods: {
    parseLocalTime (date) {
      return ParseLocalTime(date)
    },
    statusClass (status) {
      return StatusClass(status.toLowerCase())
    },
    statusClass2 (status) {
      return StatusClass2(status.toLowerCase())
    },
    tooltipDateContent (date) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      return this.$dayjs(date).tz(timezone).format('DD MMM, YYYY | hh:mm A')
    },
    applyDateFilter (filterParams) {
      const { date, startDate, status } = filterParams

      // Set the 'to' property to today's date
      this.payload.to = this.$dayjs().format('DD/MM/YYYY')

      switch (date) {
        case '30 days':
          // Subtract 30 days from today for '30 days' option
          this.payload.from = this.$dayjs()
            .subtract(30, 'days')
            .format('DD/MM/YYYY')
          break
        case '7 days':
          // Subtract 7 days from today for '7 days' option
          this.payload.from = this.$dayjs()
            .subtract(7, 'days')
            .format('DD/MM/YYYY')
          break
        case 'All Time':
          this.payload.from = '01/01/2020'
          break
        case 'custom':
          // Use start date and end date from 'custom' option
          this.payload.from = this.$dayjs(startDate[0]).format('DD/MM/YYYY')
          this.payload.to = this.$dayjs(startDate[1]).format('DD/MM/YYYY')
          break
        default:
          // Default case: clear the 'from' and 'to' properties
          this.payload.from = ''
          this.payload.to = ''
      }
      // Update the sort_by property based on the selected date option
      this.payload.sort_by =
        this.payload.sort_by && date === 'oldest to newest' ? 'created_at' : ''

      // Update the status property
      this.payload.status = status || ''
    },
    formatServerName (val) {
      let formattedName
      switch (val) {
        case this.$STATUS.AWAITING_BUSINESS_APPROVAL:
          formattedName = this.$STATUS.AWAITING_APPROVAL
          break
        default:
          formattedName = val
      }
      return FormatServerName(formattedName)
    },
    async getInitiatorDetails () {
      await this.$store
        .dispatch(
          'auth/getTransactionInitiator',
          this.transactionDetails.actorID
        )
        .then(() => {})
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    }
  }
}
